module.exports = __webpack_public_path__ + "static/media/SOUND_OFF_White.37c970d5.svg";